import React from 'react';
import { CollapseBlock } from '../../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField.jsx';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import { required } from '../../../../../antd/form/FormValidation.js';

const CategoryForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <CollapseBlock>
        <FormTextField
          label={t('Názov')}
          name={'name'}
          rules={[required(t)]}
        />

        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'wiki-categories'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      </CollapseBlock>
    </>
  );
};

export default CategoryForm;

